import { render, staticRenderFns } from "./pointManage.vue?vue&type=template&id=ca2fcdd2&scoped=true"
import script from "./pointManage.vue?vue&type=script&lang=js"
export * from "./pointManage.vue?vue&type=script&lang=js"
import style0 from "./pointManage.vue?vue&type=style&index=0&id=ca2fcdd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2fcdd2",
  null
  
)

export default component.exports